import * as React from 'react';
import { getMonthDetails, toDateString } from './common.js';
var daysMapShort = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
var monthMap = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var PickerButton = function (_a) {
    var onClick = _a.onClick, type = _a.type;
    return (React.createElement("div", { className: "mdpch-button" },
        React.createElement("div", { className: "mdpchb-inner", onClick: onClick },
            React.createElement("span", { className: "mdpchbi-".concat(type) }))));
};
export var CalendarPopup = function (_a) {
    var state = _a.state, today = _a.today, min = _a.min, max = _a.max, dispatch = _a.dispatch;
    var isDateBetweenMinMaxDate = function (date) { return date <= max && date >= min; };
    var isCurrentDay = function (date) { return date.valueOf() === today.valueOf(); };
    var isSelectedDay = function (date) { var _a; return date.valueOf() === ((_a = state.selectedDay) === null || _a === void 0 ? void 0 : _a.valueOf()); };
    var getMonthStr = function (month) { return monthMap[Math.max(Math.min(11, month), 0)] || 'Month'; };
    var onDateClick = React.useCallback(function (date) {
        dispatch({
            valid: true,
            selectedDay: date,
            showCalendar: false,
            input: toDateString(date),
        });
    }, []);
    var setYear = function (offset) {
        var year = state.year + offset;
        dispatch({
            monthDetails: getMonthDetails(year, state.month),
            year: year,
        });
    };
    var setMonth = function (offset) {
        var year = state.year;
        var month = state.month + offset;
        if (month === -1) {
            month = 11;
            year--;
        }
        else if (month === 12) {
            month = 0;
            year++;
        }
        dispatch({
            year: year,
            month: month,
            monthDetails: getMonthDetails(year, month),
        });
    };
    return (React.createElement("div", { className: "mdp-container" },
        React.createElement("div", { className: "mdpc-head" },
            React.createElement(PickerButton, { onClick: function () { return setYear(-1); }, type: "left-arrows" }),
            React.createElement(PickerButton, { onClick: function () { return setMonth(-1); }, type: "left-arrow" }),
            React.createElement("div", { className: "mdpch-container" },
                React.createElement("div", { className: "mdpchc-year" }, state.year),
                React.createElement("div", { className: "mdpchc-month" }, getMonthStr(state.month))),
            React.createElement(PickerButton, { onClick: function () { return setMonth(1); }, type: "right-arrow" }),
            React.createElement(PickerButton, { onClick: function () { return setYear(1); }, type: "right-arrows" })),
        React.createElement("div", { className: "mdpc-body" },
            React.createElement("div", { className: "c-container" },
                React.createElement("div", { className: "cc-head" }, daysMapShort.map(function (d, i) { return (React.createElement("div", { key: i, className: "cch-name" }, d)); })),
                React.createElement("div", { className: "cc-body" }, state.monthDetails.map(function (day, index) {
                    return isDateBetweenMinMaxDate(day.timestamp) ? (React.createElement("div", { className: 'c-day-container ' +
                            (day.month !== 0 ? ' disabled' : '') +
                            (isCurrentDay(day.timestamp) ? ' highlight' : '') +
                            (isSelectedDay(day.timestamp) ? ' highlight-green' : ''), key: index },
                        React.createElement("div", { className: "cdc-day" },
                            React.createElement("span", { onClick: function () { return onDateClick(day.timestamp); } }, day.date)))) : (React.createElement("div", { className: "c-day-container ".concat(isCurrentDay(day.timestamp) ? 'current-day-disabled ' : 'disabled'), key: index },
                        React.createElement("div", { className: "cdc-day" },
                            React.createElement("span", null, day.date))));
                }))))));
};
//# sourceMappingURL=CalendarPopup.js.map